import React from "react";
import { motion } from "framer-motion";

const steps = [
  { n: "01", t: "Diagnóstico", d: "Identificamos as necessidades, dificuldades e objetivos do aluno numa conversa próxima." },
  { n: "02", t: "Plano Personalizado", d: "Construímos um plano à medida — académico, emocional e de competências." },
  { n: "03", t: "Acompanhamento Contínuo", d: "Sessões regulares, com feedback estruturado e comunicação próxima com a família." },
  { n: "04", t: "Monitorização", d: "Avaliamos resultados, motivação e bem-estar — e ajustamos sempre que necessário." },
  { n: "05", t: "Objetivos & Exames", d: "Preparação focada e estratégica para alcançar metas e aprovações." },
];

export const HowItWorks = () => {
  return (
    <section id="como-funciona" data-testid="how-it-works-section" className="section bg-white">
      <div className="container-tight">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-bordeaux-700 mb-4">Como Funciona</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-stone-900 leading-tight">
              Um percurso <span className="italic text-bordeaux-700">claro e humano</span>.
            </h2>
            <p className="mt-5 text-stone-600 leading-relaxed">
              Acreditamos que o sucesso vem da clareza, da consistência e da relação. Por isso,
              o nosso método é simples — mas profundamente atento a cada aluno.
            </p>
          </div>

          <div className="lg:col-span-8">
            <ol className="space-y-5">
              {steps.map((s, i) => (
                <motion.li
                  key={s.n}
                  initial={{ opacity: 0, x: 18 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.4 }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  data-testid={`step-${s.n}`}
                  className="group flex gap-6 p-6 sm:p-7 rounded-2xl bg-stone-50 hover:bg-bordeaux-50/40 border border-stone-100 hover:border-bordeaux-200 transition-all"
                >
                  <div className="font-display text-3xl sm:text-4xl text-bordeaux-700/80 group-hover:text-bordeaux-700 transition-colors min-w-[3.5rem]">
                    {s.n}
                  </div>
                  <div>
                    <div className="font-display text-xl sm:text-2xl text-stone-900">{s.t}</div>
                    <p className="mt-1.5 text-stone-600 leading-relaxed text-sm sm:text-base">{s.d}</p>
                  </div>
                </motion.li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};
